import { useAuth0 } from "@auth0/auth0-react";
import styles from "./Sendcontact.module.css";
import { Autocomplete, Chip, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import { useEffect, useState } from "react";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";

const schema = yup.object().shape({
    group_id: yup.string().required('This field is Required')
});

const SendContact = ({ setAddModalOpen, campaign, setSnackbarOpen, setSnackbarMsg, setLoading }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [groupList, setGroupList] = useState([]);
    const [emails, setEmails] = useState([]);
    const [noOfContacts, setNoOfContacts] = useState(null);

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    const { handleSubmit, control, errors } = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange'
    });

    useEffect(() => {
        const getGroupList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/groups", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setGroupList(response.data.data);
            }).catch(() => {
            });
        }
        getGroupList();
    }, [getAccessTokenSilently]);

    const onSubmit = async (data) => {
        setLoading(true);
        setAddModalOpen(false);

        data = { ...data, emails: emails };

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_USER_API_URL + 'v1/campaign/send-email/' + campaign?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);
            setSnackbarOpen(true);
            setSnackbarMsg('Mail sent successfully.');

        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<div className={`${styles.AddPropertyRow}`}>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={`${styles.AddPropertyHalfSec}`}>
                <div className={`${styles.AddPropertyHalfSecRow}`}>
                    <div className={`${styles.HalfSecFull} FormGroup`}>
                        <TextField id="outlined-basic" label="Campaign Name*" variant="outlined" defaultValue={campaign?.title} disabled />
                    </div>
                    <div className={`${styles.HalfSecFull} FormGroup`}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Group*</InputLabel>
                            <Controller
                                name="group_id"
                                control={control}
                                render={(field) => (<Select
                                    {...field}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Group*"
                                    onChange={(e) => {
                                        field.onChange(e);

                                        let selGroup = groupList?.filter(i => i?.id === e.target.value);
                                        if (selGroup.length) {
                                            selGroup = selGroup[0];
                                            setNoOfContacts(selGroup?.no_of_contacts);
                                        } else {
                                            setNoOfContacts(0);
                                        }
                                    }}
                                >
                                    <MenuItem value={0}>No Group</MenuItem>
                                    {groupList?.map((i) => {
                                        return <MenuItem value={i?.id}>{i?.title}</MenuItem>
                                    })}
                                </Select>)}
                            />
                        </FormControl>
                        {errors.group_id && (<p className={`${styles.ErrorM}`}>{errors.group_id.message}</p>)}
                        {noOfContacts !== null && <p style={{ margin: 0 }}>No of contacts: {noOfContacts}</p>}
                    </div>
                    <div className={`${styles.HalfSecFull} FormGroup`}>
                        <Autocomplete
                            multiple
                            freeSolo
                            options={[]}
                            value={emails}
                            onChange={(event, newValue) => {
                                const validOnly = newValue.filter((email) => isValidEmail(email));

                                console.log(newValue);
                                console.log(validOnly);

                                setEmails(validOnly);
                            }}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip label={option} {...getTagProps({ index })} />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField {...params} variant="outlined" label="Emails" placeholder="Add email" />
                            )}
                        />

                    </div>
                </div>
            </div>
            <div className={`${styles.ButtonSec}`}>
                <button type="button" onClick={(e) => setAddModalOpen(false)} className="CancelPopupBU">Cancel</button>
                <button type="submit" className="SubmitPopupBU">Send</button>
            </div>
        </form>
    </div >);
}

export default SendContact;